<script>
  import * as restfulService from '../../../../../../app/services/restfulService'
  import * as notifyService from '../../../../../../app/services/notifyService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  import {required} from 'vuelidate/lib/validators'

  export default {
    mixins: [helpers],
    name: 'paper-show-screening',
    props: ['paper'],
    data () {
      return {
        isSubmitted: false
      }
    },
    validations: function () {
      return {
        paper: {
          notes: {required}
        }
      }
    },
    computed: {
      paperStatusKey: function () {
        return this.paper.status.key
      },
      isInvoiceOpened: function () {
        return this.paper.registration.status.key === 'em_aberto'
      },
      isInvoicePaid: function () {
        return this.paper.registration.status.key === 'pago'
      },
      isEditDaysAvailable: function () {
        return this.paper.event_paper_type.edit_limit_days > 0 &&
          this.momentInstance(this.paper.date_submitted)
            .add(this.paper.event_paper_type.edit_limit_days, 'days')
            .isBetween(
              this.momentNow(),
              this.momentNow().add(this.paper.event_paper_type.edit_limit_days, 'days')
            )
      },
      canBeApproved: function () {
        return (this.isInvoicePaid && this.paper.event_paper_type.edit_limit_days === 0) || (this.isInvoicePaid && !this.isEditDaysAvailable) || (!this.isEditDaysAvailable || this.paper.event_paper_type.edit_limit_days === 0)
      },
      hasScreening: function () {
        return this.paper.event_paper_type.screening
      },
      showScreeningOption: function () {
        return (this.hasScreening && this.paperStatusKey === 'nao_designado') ||
          (!this.hasScreening && this.paperStatusKey === 'aprovado_pela_triagem')
      }
    },
    methods: {
      onAcceptPaper () {
        bus.$emit('show-loader')
        let data = {
          id: this.paper.id,
          status: 'accept',
          notes: this.paper.notes
        }
        this.onScreeningPaper(data)
      },
      onRejectPaper () {
        bus.$emit('show-loader')
        let data = {
          id: this.paper.id,
          status: 'rejected',
          notes: this.paper.notes
        }
        this.onScreeningPaper(data)
      },
      onScreeningPaper (data) {
        bus.$emit('show-loader')
        this.isSubmitted = true
        restfulService.put('paper', 'update-status', data.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            bus.$emit('papers-reload-list')
            this.isSubmitted = false
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <table class="table-confirmation" v-if="showScreeningOption">
        <thead>
        <tr>
            <th colspan="2">Liberação do Trabalho</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="hasScreening && showScreeningOption && canBeApproved">
            <td>
                <el-form ref="formPaper"
                         :model="paper"
                         label-width="20%">
                    <el-form-item label="Observações">
                        <el-input v-model="paper.notes"
                                  type="textarea"
                                  :rows="5"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success"
                                   @click="onAcceptPaper"
                                   :disabled="isSubmitted">
                            <i class="fa fa-check"></i>
                            <span>Aprovado</span>
                        </el-button>
                        <el-button type="danger"
                                   @click="onRejectPaper"
                                   :disabled="isSubmitted || $v.paper.$invalid">
                            <i class="fa fa-times"></i>
                            <span>Reprovado</span>
                        </el-button>
                        <span class="helper-text">Para reprovar o trabalho você precisa fornecer uma resposta ao autor</span>
                    </el-form-item>
                </el-form>
            </td>
        </tr>
        <tr v-if="!showScreeningOption">
            <td>
                <el-alert v-if="isInvoiceOpened"
                          title="Trabalho aguardando liberação"
                          type="error"
                          description="Pagamento da inscrição do autor não confirmado."
                          :closable="false"
                          show-icon>
                </el-alert>
                <el-alert v-if="isInvoicePaid && isEditDaysAvailable"
                          title="Trabalho aguardando liberação"
                          type="error"
                          description="O trabalho ainda está no período de edição."
                          :closable="false"
                          show-icon>
                </el-alert>
            </td>
        </tr>
        </tbody>
    </table>
</template>



// WEBPACK FOOTER //
// Screening.vue?2999b659